import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { ui } from '@/constants';
import { AlternatePickupLocations } from '@/models/alternate-pickup-locations';
import { Restaurant, RestaurantAddress } from '@/models';
import moment from 'moment';
import { calculateDistance, getDistanceUnit } from '@/helpers';
import { AlternatePickupLocationsVisibleEvent } from '@/services/analytics/events';

@Component({
  name: 'CmgAlternatePickupLocationsModal',
})
export default class CmgAlternatePickupLocationsModal extends Vue {
  selectionRequired = false;
  selectedRestaurant: Restaurant | null = null;
  loadingRestaurantInfo = false;
  
  get args() {
    return this.$appStore.state.ui.modals.alternatePickupLocationsModal.args;
  }

  get visible(): boolean {
    return this.$appStore.state.ui.modals.alternatePickupLocationsModal.visible;
  }

  get closeIconUrl(): string {
    return this.$appStore.state.cms.images.buttons.xDarkBrown.default;
  }

  get alternatePickupLocations(): AlternatePickupLocations | null {
    return (this.args && this.args.alternatePickUpLocations) || null;
  }

  get isMobile(): boolean {
    return this.$appStore.state.ui.clientWidth <= ui.breakpoints.phoneSmMax;
  }
  
  get checkMarkUrl(): string {
    return this.$appStore.state.cms.images.icons.checkMarkSelected.default;
  }
  
  @Watch('visible')
  async onVisibleUpdated(visible: boolean) {
    if (!visible || !this.args) {
      return;
    }
    this.$services.analytics.send(new AlternatePickupLocationsVisibleEvent());
    this.loadingRestaurantInfo = true;
    this.updateLocationAddresses();
  }

  close() {
    this.selectionRequired = false;
    this.selectedRestaurant = null;
    this.$services.ui.setModalVisibility('alternatePickupLocationsModal', false);
    this.$services.ui.focusBack();
  }

  setSelectedRestaurant(restaurant: Restaurant) {
    this.selectedRestaurant = restaurant;
    this.selectionRequired = false;
  }

  async onClickChangeLocation() {
    if (!this.args || !this.selectedRestaurant) {
      this.selectionRequired = true;
      return;
    }

    this.args.onAlternateLocationSelected(this.selectedRestaurant);
    this.close();
  }

  async updateLocationAddresses() {
    if (this.alternatePickupLocations?.alternatePickupRestaurants) {
      let results: Promise<void|Restaurant>[] = [];
      for (const alternateRestaurant of this.alternatePickupLocations?.alternatePickupRestaurants) {
        if (this.alternatePickupLocations?.alternatePickupRestaurants[0].restaurantId) {
          results.push(this.$services.restaurant.getRestaurantByNumber(alternateRestaurant.restaurantId).then((restaurant) => {
            alternateRestaurant.restaurant = restaurant;
          }));
        }
      }

      await Promise.all(results);
      this.loadingRestaurantInfo = false;
    }
  }
  
  getAddressLine2(address: RestaurantAddress): string {
    const postalCodeSplit = address.postalCode ? address.postalCode.split('-') : [];
    const postalCode = postalCodeSplit.length > 0 ? postalCodeSplit[0] : address.postalCode;
    return `${address.locality}, ${address.administrativeArea ? address.administrativeArea + ' ' : ''}${postalCode}`; 
  }

  getFormattedTime(dateTime: string) {
    return moment(new Date(dateTime)).format('h:mma');
  }

  getFormattedDistance(countryCode: string, distance: number){
    return `${(calculateDistance(countryCode, distance)).toFixed(1)} ${getDistanceUnit(countryCode)}`
  }
}
